export const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION || 'vývojová verze';
export const APP_BUILD_DATE = process.env.NEXT_PUBLIC_APP_BUILD_DATE || '';
